// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2AYyC","footer":"ModalFilter_footer__ef_QJ"};